import { useState } from 'react';
import { ChevronDown, Users, CreditCard, Calendar } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
  icon: typeof Users;
}

const faqs: FAQItem[] = [
  {
    question: "Cui se adresează?",
    answer: "Sportivi pentru downhill și gravity",
    icon: Users
  },
  {
    question: "Ce include?",
    answer: "Legitimare FRC/UCI si un  jersey de club",
    icon: CreditCard
  },
  {
    question: "Când au loc antrenamentele / concursurile?",
    answer: "În weekend sau full week în vacanțele școlare. Iar cantonamentele și concursurile durează 5-6 zile",
    icon: Calendar
  }
];

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4">Întrebări Frecvente</h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Află mai multe despre programele și activitățile noastre
        </p>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => {
            const Icon = faq.icon;
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full text-left px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <div className="bg-orange-100 p-2 rounded-lg">
                      <Icon className="w-6 h-6 text-orange-500" />
                    </div>
                    <span className="font-semibold text-lg">{faq.question}</span>
                  </div>
                  <ChevronDown
                    className={`w-5 h-5 text-gray-500 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                
                <div
                  className={`px-6 overflow-hidden transition-all duration-200 ease-in-out ${
                    isOpen ? 'py-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-gray-600 pl-16">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}